import lifeEventTheme from './lifeEventTheme';
import lifeEventCategory from './lifeEventCategory';
import lifeEvent from './lifeEvent';
import encouragement from './encouragement';
import company from './company';
import templateLifeEventTheme from './templateLifeEventTheme';
import templateLifeEventCategory from './templateLifeEventCategory';
import templateLifeEvent from './templateLifeEvent';
import templateEncouragement from './templateEncouragement';

export default {
  lifeEventTheme,
  lifeEventCategory,
  lifeEvent,
  encouragement,
  company,
  templateLifeEventTheme,
  templateLifeEventCategory,
  templateLifeEvent,
  templateEncouragement,
};



// WEBPACK FOOTER //
// ./src/schemas/curator/index.js